import Box from "@/shared/components/common/Box";
import { cn } from "@/shared/libs/commonUtils";

interface HTMLContentServerProps {
  html: TrustedHTML;
  className?: string;
  truncated?: boolean;
  collapsedHeight?: number;
}

export function HTMLContentServer({
  html,
  className,
  truncated,
  collapsedHeight,
}: HTMLContentServerProps) {
  return (
    <Box
      className={cn(
        "html-content-wrapper",
        truncated && "overflow-hidden",
        className,
      )}
      style={truncated ? { maxHeight: collapsedHeight } : undefined}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
